import axiosClient from "api/axios_client.js";

const apiLoginHistory = {
  getAllLoginHistory: (payload) => axiosClient.post(`/user/get-all-login-audit`, payload),
  deleteLoginHistory: (ids) => axiosClient.delete(`/user/delete-user-login-audit`, { data: { ids }}),
};

export default apiLoginHistory;


